import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-09203894"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-user" }
const _hoisted_2 = { class: "identification_title" }
const _hoisted_3 = { class: "form-group" }

import { Countries } from "@/models/const/countries";
import { UserModel } from "./models";
import { onMounted, onUnmounted, ref } from "vue";
import { AdapterApiService } from "../_adapter";
import * as Routes from "@/router/routerNames";
import { AdapterAuthService } from "../login/adapter";
import AdapterLoginService from "../login/adapter/AdapterAuthService";
import EnumTypeIdentified from "@/api/main/dataSource/api/aba/data/models/models/EnumTypeIdentified";
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'identification-new-user',
  emits: ["continue"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const isLoading = ref(false);
const userInfo = ref(new UserModel());
const countries = Countries;
const router = useRouter();
onMounted(async () => {

});

function startContinue() {
	if (isValid(userInfo.value)) {
		emits("continue", userInfo.value);
		isLoading.value = true;
	}
}
function isValid(value: UserModel) {
	return true;
}
function isDisabled(): boolean {
	const res = !(
		userInfo.value.FirstName &&
		userInfo.value.LastName &&
		userInfo.value.CountyState &&
		userInfo.value.Address1 &&
		userInfo.value.City &&
		userInfo.value.PostCode
	);
	return res;
}
onUnmounted(() => {
	isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_select_autocomplete = _resolveComponent("ui-select-autocomplete")!
  const _component_continue_button = _resolveComponent("continue-button")!
  const _directive_localization = _resolveDirective("localization")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("span", null, null, 512), [
        [_directive_localization, 'New user']
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ui_input, {
        class: "pb-4",
        modelValue: userInfo.value.FirstName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userInfo.value.FirstName) = $event)),
        headerText: _ctx.$localization.getTranslate('First name'),
        warningMsg: _ctx.$localization.getTranslate('FillThisField'),
        required: ""
      }, null, 8, ["modelValue", "headerText", "warningMsg"]),
      _createVNode(_component_ui_input, {
        class: "pb-4",
        modelValue: userInfo.value.LastName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userInfo.value.LastName) = $event)),
        headerText: _ctx.$localization.getTranslate('Last name'),
        warningMsg: _ctx.$localization.getTranslate('FillThisField'),
        required: ""
      }, null, 8, ["modelValue", "headerText", "warningMsg"]),
      _createVNode(_component_ui_select_autocomplete, {
        keyField: "value",
        valueField: "text",
        selectText: "value",
        items: _unref(countries),
        class: "indentification-input",
        style: {"flex":"0.5"},
        headerText: _ctx.$localization.getTranslate('Header.Country') + '*',
        noUndefined: true,
        modelValue: userInfo.value.CountyState,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userInfo.value.CountyState) = $event))
      }, null, 8, ["items", "headerText", "modelValue"]),
      _createVNode(_component_ui_input, {
        class: "pb-4",
        modelValue: userInfo.value.City,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userInfo.value.City) = $event)),
        headerText: _ctx.$localization.getTranslate('City'),
        warningMsg: _ctx.$localization.getTranslate('FillThisField'),
        required: ""
      }, null, 8, ["modelValue", "headerText", "warningMsg"]),
      _createVNode(_component_ui_input, {
        class: "pb-4",
        modelValue: userInfo.value.Address1,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userInfo.value.Address1) = $event)),
        headerText: _ctx.$localization.getTranslate('Address1'),
        warningMsg: _ctx.$localization.getTranslate('FillThisField'),
        required: ""
      }, null, 8, ["modelValue", "headerText", "warningMsg"]),
      _createVNode(_component_ui_input, {
        modelValue: userInfo.value.PostCode,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userInfo.value.PostCode) = $event)),
        headerText: _ctx.$localization.getTranslate('Postcode'),
        warningMsg: _ctx.$localization.getTranslate('FillThisField'),
        required: ""
      }, null, 8, ["modelValue", "headerText", "warningMsg"])
    ]),
    _createVNode(_component_continue_button, {
      onClick: startContinue,
      class: "company_continue",
      buttonText: _ctx.$localization.getTranslate('Button.Continue'),
      isLoading: isLoading.value,
      disabled: isDisabled()
    }, null, 8, ["buttonText", "isLoading", "disabled"])
  ]))
}
}

})